export const convertHtml = (text: string) => {
  if( process.client ) {
    const parser = new DOMParser();
    const decodedHtml = parser.parseFromString(text, "text/html").body
      .textContent;
    return decodedHtml;
  }else {
    return text;
  }
};
